import React from 'react';
import { useStageClickedOn } from 'state/canvas/stage-clicked-on';
import { useSelectedNode } from 'state/canvas/selected-node';
import {
  useIsLinkArrowShown,
  useNodeLinkingOperations,
} from 'state/canvas/node-linking';
import {
  useLinkMenuPositionOperation,
  useSelectedLinkOperations,
} from 'state/canvas/selected-link';
import { useRiskMenuPositionOperation } from 'state/canvas/selected-risk';

export interface CanvasStageListenersProps {
  surface: string;
}

const defaultProps = {};

function CanvasStageListeners(props: CanvasStageListenersProps) {
  const [stageClickedOn] = useStageClickedOn();

  const [selectedNode, setSelectedNode] = useSelectedNode();

  const isLinkArrowShown = useIsLinkArrowShown();

  const { clearLink, getCurrentLink } = useNodeLinkingOperations();

  const { clearLinkMenuPosition } = useLinkMenuPositionOperation();

  const { clearSelectedLink } = useSelectedLinkOperations();

  const { clearRiskMenuPosition } = useRiskMenuPositionOperation();

  React.useEffect(() => {
    if (isLinkArrowShown) {
      // We only clear position because we want to remove SurfaceLinkContextMenu...selected link is connected to logic of showing link arrows.
      clearLinkMenuPosition();
      clearSelectedLink();
    }
  }, [isLinkArrowShown]);

  React.useEffect(() => {
    clearLinkMenuPosition();
    clearSelectedLink();
    clearRiskMenuPosition();
  }, [stageClickedOn]);

  React.useEffect(() => {
    if (stageClickedOn && selectedNode && isLinkArrowShown === false) {
      setSelectedNode(null);
    }
  }, [stageClickedOn]);

  React.useEffect(() => {
    const link = getCurrentLink();

    if (link.from || link.to) {
      clearLink();
    }
  }, [props.surface]);

  return null;
}

CanvasStageListeners.defaultProps = defaultProps;

export default CanvasStageListeners;
